<template>
  <div class="header" id="myHeader">
    <b-container>
      <b-row>
        <b-col md="6" class="chart">
          <span class="result-title"> Result </span>
          <apexchart
            type="donut"
            width="370"
            :options="chartOptions"
            :series="series"
          ></apexchart>
        </b-col>
        <b-col md="6">
          <b-row class="justify-content-md-center" align-v="center">
            <b-col sm="6">
              <h1 class="title">TOTAL</h1>
              <h3 class="title-details">
                <span> {{ total }} </span>
                journeys
              </h3>
            </b-col>
            <b-col sm="6">
              <b-button class="add-btn" @click="addJourney">
                + ADD A JOURNEY
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import apexchart from "vue-apexcharts";
export default {
  name: "JourneysHeader",
  props: ["total", "percentages"],
  components: {
    apexchart
  },
  data() {
    return {
      series: [20, 30, 20, 30],
      chartOptions: {
        chart: {
          width: "100%",
          height: "100",
          type: "donut",
          colors: ["#8F99FC", "#FF8C7D", "#F6F28B", "#65EA82"]
        },
        colors: ["#8F99FC", "#FF8C7D", "#F6F28B", "#65EA82"],
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: 0
        },
        states: {
          hover: {
            filter: {
              type: "lighten",
              value: 0
            }
          }
        },
        responsive: [
          {
            breakpoint: 767,
            options: {
              legend: {
                position: "bottom"
              },
              chart: {
                // width: 250,
                // height: 400,
              }
            }
          },
          {
            breakpoint: 510,
            options: {
              chart: {
                width: 250,
                height: 400
              },
              legend: {
                // show: false,
                position: "bottom",
                fontSize: "14px"
              }
            }
          },
          {
            breakpoint: 370,
            options: {
              chart: {
                width: 210,
                height: 400
              },
              legend: {
                // show: false,
                position: "bottom",
                fontSize: "12px"
              }
            }
          },
          {
            breakpoint: 319,
            options: {
              chart: {
                width: 200
                // height: 400,
              },
              legend: {
                // show: false,
                position: "bottom",
                fontSize: "12px"
              }
            }
          }
        ],

        legend: {
          position: "right",
          offsetY: 0,

          height: 121,
          fontSize: "14px",
          fontFamily: "Nunito, sans-serif",
          fontWeight: 400,
          markers: {
            fillColors: ["#8F99FC", "#FF8C7D", "#F6F28B", "#65EA82"],
            customHTML: function() {
              return '<span class="custom-marker"></span>';
            }
          },
          itemMargin: {
            horizontal: 5,
            vertical: 3
          }
          // fill: {
          // },
        }
      }
    };
  },
  computed: {
    labelsComp() {
      return [
        this.getlabel("SPIRITUAL", 0),
        this.getlabel("HEALTH", 1),
        this.getlabel("EDUCATION", 2),
        this.getlabel("FINANCE", 3)
      ];
    }
  },
  methods: {
    addJourney() {
      this.$bvModal.show("my-journeys");
      this.$emit("toogleEditMode");
    },
    getlabel(label, index) {
      return label + " " + "&nbsp;" + "&nbsp;" + this.series[index] + "%";
    }
  },
  watch: {
    percentages(newValue, oldValue) {
      if (newValue) {
        this.series = [
          parseInt(this.percentages.s),
          parseInt(this.percentages.h),
          parseInt(this.percentages.e),
          parseInt(this.percentages.f)
        ];
      }
    }
  },
  created() {
    this.chartOptions.labels = this.labelsComp;
  }
};
</script>

<style lang="scss" scoped>
.header {
  background-color: #fafbff;

  padding-top: 32px;
  padding-bottom: 32px;
  font-family: "Nunito", sans-serif;

  .title {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    text-transform: uppercase;

    color: #8d99a0;
  }
  h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    color: #474d52;
    span {
      font-weight: bold;
      font-size: 48px;
      line-height: 65px;

      text-transform: uppercase;
      color: #557efb;
      padding-right: 14px;
    }
  }
  .add-btn {
    // padding: 10px 32px;
    max-width: 189px;

    width: 100%;
    height: 39px;
    font-style: normal;
    font-weight: bold;
    text-align: center;
    font-size: 14px;
    line-height: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #557efb;
    background: rgba(85, 126, 251, 0.1);
    border-radius: 100px;
    border: none;
    margin-top: 10px;
    transition: 0.3s linear;
    &:hover {
      background-color: #496cd4 !important;
      color: #fff;
    }
    &:focus {
      border: none;
      outline: none;
      box-shadow: none;
    }
  }
}
.logo {
  font-family: "Nunito", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  line-height: 27px;
  display: flex;
  align-items: center;
  color: #474d52;
  margin-bottom: 32px;
  span {
    margin-right: 16px;
    width: 30px;
    height: 30px;
    margin-bottom: 3px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
.chart {
  position: relative;
  .result-title {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.05em;
    color: #b3c2cb;
    position: absolute;
    top: 43%;
    left: 13%;
    // display: none;
    @media (max-width: 1130px) {
      top: 43%;
      left: 18%;
      // font-size: 16px;
    }
    @media (max-width: 990px) {
      top: 43%;
      left: 23%;
      // font-size: 16px;
    }
    @media (max-width: 767px) {
      top: 25%;
      left: 46%;
      font-size: 16px;
    }
    @media (max-width: 510px) {
      top: 29%;
      left: 45%;
      font-size: 16px;
    }
    @media (max-width: 370px) {
      top: 27%;
      left: 40.5%;
      font-size: 16px;
    }
  }
}
.chart::after {
  content: "";
  position: absolute;
  top: 21%;
  height: 65%;
  width: 1px;
  background: #ddd;
  right: 100px;
  display: none;
}
@media (max-width: 950px) {
  .chart::after {
    display: none;
  }
}
@media (max-width: 767px) {
  .header .title {
    text-align: center;
  }
  .header h3 {
    justify-content: center;
  }
  .header .add-btn {
    margin-left: auto;
    margin-right: auto;
  }
  .chart {
    position: relative;
    display: flex;
    justify-content: center;
  }
}
@media (max-width: 480px) {
  .chart {
    display: flex;
    justify-content: center;
  }
}
</style>
